export default "__VITE_ASSET__BSy5NXGL__"